<!-- sku批量修改 -->
<template>
  <div class="sku-bluk" @click.stop>
    <!-- 起订量\重量\库存 -->
     <template v-if="field=='Case' || field=='Weight' || field=='Inventory' ">
        <el-input
          v-model="enterValue" :placeholder="field | disPlaceholder"
          oninput="if(value){value=value.replace(/^(0+)|[^\d]+/g,'')}  if(value>10000){value=10000}"
        ></el-input>
        <div class="required-error" v-show="!enterValue">Please enter</div>
     </template>

    <!-- FOB Price\Cost Price\Procurement Price\\Wholesale Settlement Price\Retail Price -->
    <template v-if="field=='FOB Price' || field=='Cost Price' || field=='Procurement Price' || field=='Wholesale Settlement Price' ||field=='Retail Price' ||field=='Wholesale Price' ">
      <el-input placeholder="0.00" v-model="enterValue"
                oninput="if(value){value=value.replace(/[^0-9.]/g,'')} if(value){value=value.replace(/^()*(\d+)\.(\d\d).*$/, '$1$2.$3')}"
                class="input-with-select" style="width: 220px;">
        <el-select v-model="operator" slot="prepend" placeholder="Please Select">
          <el-option label="+" value="+"></el-option>
          <el-option label="-" value="-"></el-option>
          <el-option label="*" value="*"></el-option>
        </el-select>
      </el-input>
      <div class="required-error" v-show="!enterValue">Please enter</div>
    </template>

    <!-- Dimensions -->
    <template v-if="field=='Dimensions' ">
        <div class="dimensions-info">
          <el-input style="width: 70px;"
                    oninput="if(value){value=value.replace(/^(0+)|[^\d]+/g,'')} if(value>1000){value=1000}"
                    placeholder="L (cm)" v-model="length"></el-input>
          <el-input style="width: 70px;"
                    oninput="if(value){value=value.replace(/^(0+)|[^\d]+/g,'')}  if(value>1000){value=1000}"
                    placeholder="W (cm)" v-model="width"></el-input>
          <el-input style="width: 70px;"
                    oninput="if(value){value=value.replace(/^(0+)|[^\d]+/g,'')}  if(value>1000){value=1000}"
                    placeholder="H (cm)" v-model="height"></el-input>
        </div>
       <div class="required-error" v-show="!length||!width||!height">Please enter</div>
    </template>

    <!-- Availability -->
    <template v-if="field=='Availability' ">
      <el-select style="width: 160px; padding: 5px 5px 2px;" placeholder="Please Select" v-model="enterValue" @change="changeStatus">
        <el-option
          v-for="item in skuStatusOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>

      <el-date-picker
        v-if="enterValue == '0'"
        v-model="batchRestockDate"
        style="margin-top: 5px;width: 160px;"
        type="date"
        value-format="MM/dd/yyyy"
        placeholder="MM/DD/YYYY"
        format="MM/dd/yyyy"
      >
      </el-date-picker>

      <div class="required-error" v-show="goodsStatusDb=='0'">Please set SPU Active first</div>
      <div class="required-error" v-show="(!enterValue || (enterValue=='0' && !batchRestockDate)) && goodsStatusDb!=='0'">Please Select</div>
    </template>



    <div class="btn" @click="submit">Bluk Set</div>


  </div>
</template>

<script>
import {skuStatusArr} from "../../utils/status";
export default {
  components: {

  },
  props:{
    field:String
  },
  data() {
    return {
      skuStatusOptions: skuStatusArr,
      enterValue:'',
      operator:'+',
      length:'',
      width:'',
      height:'',
      batchRestockDate:'',
      showRestockDate:false,
      goodsStatusDb:'',
    }
  },
  created() {
  },
  mounted(){
    this.goodsStatusDb = this.$parent.$parent.$parent.goodsStatusDb
  },
  filters: {
    disPlaceholder(obj) {
      return 'Enter ' + obj
    },
  },

  methods: {
    changeStatus(e){
      this.showRestockDate = (e == '0')
    },
    submit(){
      if (this.enterValue && (this.field === 'Case' || this.field === 'Weight' || this.field === 'Inventory')) {
        this.$parent.$parent.$parent.blukSetSku('num', this.enterValue)
      }
      else if (this.enterValue && (this.field == 'FOB Price' || this.field == 'Cost Price' ||
        this.field == 'Procurement Price' || this.field == 'Wholesale Settlement Price' || this.field == 'Retail Price' || this.field == 'Wholesale Price')) {
        this.$parent.$parent.$parent.blukSetSku('float', this.enterValue, this.operator)
      }
      else if (this.field == 'Dimensions' && this.length && this.width && this.height) {
        this.$parent.$parent.$parent.blukSetSku('num-dim', this.length, this.width, this.height)
      }
      else if (this.field == 'Availability' && this.goodsStatusDb !== '0' && this.enterValue &&
        (this.enterValue !== '0' || (this.enterValue == '0' && this.batchRestockDate))) {
        this.$parent.$parent.$parent.blukSetSku('status', this.enterValue, this.batchRestockDate)
      }

    },
  }
}

</script>

<style lang="less" scoped>
/deep/ .el-input__inner{
  padding: 0 5px !important;
}
/deep/ .el-date-editor .el-input__inner{
  padding-left: 25px !important;
}
/deep/ .input-with-select .el-input-group__prepend{
  background: #FFFFFF;
}
.sku-bluk{
  border: 1px solid #707070;
  border-radius: 3px;
  position: absolute;
  z-index: 999;
  top: 0px;
  background: #FFFFFF;

  .el-input {
    padding: 5px 5px 2px;
    width: 200px;
  }

  .dimensions-info{
    display: flex;

  }

  .required-error {
    color: #F77073;
    padding-left: 5px;
    font-size: 12px;
  }
  .btn{
    margin-top: 5px;
    cursor: pointer;
    width: 100%;
    background: #262B2F;
    color: #FFFFFF;
    height: 40px;
    line-height: 40px;
    text-align: center;
  }
}


</style>




// WEBPACK FOOTER //
// src/pages/spuDetails/sku-bluk-set.vue